module.exports = __webpack_public_path__ + "static/media/Togetic_gaussian2.02a30c4f.png";